export default __webpack_public_path__ + "static/media/plattform_highlight.fe029371.png";